import type { ReactNode } from 'react';

/**
 * Shared layout for every auth-flow page (login, register, reset
 * request/confirmation/token/success, select-client).
 *
 * Renders a centered card on a dark canvas with the brand mark up
 * top, an optional title/subtitle, and your page content beneath.
 * The footer slot is for "don't have an account?" / "back to login"
 * style cross-page links.
 */
interface AuthShellProps {
  /** Card title - typically the page name (Login, Register, etc.). */
  title?: string;
  /** Optional one-line explainer under the title. */
  subtitle?: string;
  /** The form / main content. */
  children: ReactNode;
  /** Optional below-card cross-page navigation (registration link,
   *  forgot-password link, etc.). */
  footer?: ReactNode;
}

export function AuthShell({ title, subtitle, children, footer }: AuthShellProps) {
  return (
    <div className="auth-shell">
      <main className="auth-shell-main">
        <div className="auth-card">
          <div className="auth-card-header">
            {/* Dark-mode logo because the auth shell is dark-locked.
                Absolute path so Flask's /static handler serves it
                regardless of the SPA's '/platform/' asset base. */}
            <img
              className="auth-card-logo"
              src="/static/img/locksmith-logo-dark-mode.png"
              alt="Locksmith"
            />
            {title && <h1 className="auth-card-title">{title}</h1>}
            {subtitle && <p className="auth-card-subtitle">{subtitle}</p>}
          </div>

          {children}

          {footer && <div className="auth-card-footer">{footer}</div>}
        </div>
      </main>

      <footer className="auth-shell-footer">
        Locksmith: Unlock knowledge for your team
      </footer>
    </div>
  );
}
